import { useSpecimen } from "./Offers";

/**
 * Trois pages d'un vrai rapport, sous l'offre — 11/10/2026.
 *
 * ## Pourquoi
 *
 * Les premiers compteurs de la fenêtre de paiement le disaient : sur sept
 * ouvertures, six se refermaient dès le premier écran, sans aucun choix. Le
 * bouton « Obtenir mon rapport » servait à **voir** ce qu'il y a dedans, et
 * ouvrait une caisse. On montre donc le document avant le bouton.
 *
 * ## Ce que ces pages sont, et ce qu'elles ne sont pas
 *
 * Trois pages du rapport d'exemple publié (`/specimen`) — couverture, liste des
 * dix actions, une action détaillée — rendues en images légères. Un profil
 * **fictif**, et la légende le dit : montrer un document comme s'il était
 * celui de la personne serait le faux signal que la règle n° 6 interdit. Le
 * lien vers le rapport entier n'apparaît que si le spécimen est réellement
 * publié : un lien mort coûte plus cher que pas de lien.
 *
 * Quand le gabarit du rapport change, ces images se régénèrent depuis le
 * spécimen (pdftoppm, 340 px de large, WebP) dans `public/apercu/`.
 */
const PAGES = [
  { n: 1, alt: "Couverture d'un rapport d'exemple : indice, heures récupérables et valeur du temps" },
  { n: 4, alt: "Page d'un rapport d'exemple : les dix actions classées par heures rendues" },
  { n: 5, alt: "Page d'un rapport d'exemple : une action détaillée, avec ses étapes et le texte à copier" },
] as const;

export function ApercuRapport() {
  const specimen = useSpecimen();
  return (
    <figure className="apercu-rapport">
      <div className="apercu-pages">
        {PAGES.map((p) => (
          <img
            key={p.n}
            src={`/apercu/rapport-p${p.n}.webp`}
            alt={p.alt}
            width={340}
            height={481}
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>
      <figcaption className="fine">
        Extrait d'un rapport d'exemple, sur un profil fictif — le vôtre porte sur vos tâches.{" "}
        {specimen && (
          <a href="/specimen" target="_blank" rel="noopener noreferrer">
            Le lire en entier
          </a>
        )}
      </figcaption>
    </figure>
  );
}
